import React, { Component } from 'react';
import { navigate } from '@reach/router';
import { getPageSlugFromUrl, getPageUrlFromSlug } from '../../../utilities/urlHelper';
import InlineReference from './InlineReference';

class PageReference extends Component {
    onClick = (e) => {
        if (!e.metaKey && window.isApp) {
            e.preventDefault();
            e.stopPropagation();
            const { entityKey, contentState } = this.props;
            const { url, title } = contentState.getEntity(entityKey).getData();
            const slug = getPageSlugFromUrl(url);
            const pageUrl = getPageUrlFromSlug(slug);
            const context = 'pageReference';

            return navigate(pageUrl, { state: { title, context } });
        }
    };

    render() {
        const { entityKey, contentState } = this.props;
        const { url } = contentState.getEntity(entityKey).getData();
        const slug = getPageSlugFromUrl(url);
        const pageUrl = getPageUrlFromSlug(slug);

        return (
            <InlineReference
                url={pageUrl}
                cssSelector="tettra-page"
                onClick={this.onClick}
                isInternalReference
                {...this.props}
            />
        );
    }
}

export default PageReference;
